import { BREAKPOINTS } from "../config/breakpoints";
import React, { useLayoutEffect, useRef, useState } from "react";
import styled from "styled-components";
import Card from "../Generic/Card";
import { Cross, Tickmark } from "../Generic/Symbols";
import { zIndex } from "../config/zIndex";

const ModulesWrapper = styled.div`
	height: 20rem;
	width: 100%;
	position:relative;
`;

const Module = styled.div`
	box-shadow: rgba(0, 0, 0, 0.12) 0px 1px 3px, rgba(0, 0, 0, 0.24) 0px 1px 2px;
	border-radius: 10px;
	height: max-content;
	width: 100px;
	padding: 0.5rem 0;
	position: absolute;
	transform: ${({ x, y }) => `translate(${x}px, ${y}px)`};
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	font-size: clamp(12px, 1vw, 16px);
	transition: 100ms all linear;
	&:hover {
		cursor: pointer;
	}
`;

const Overlay = styled.div`
	position: fixed;
	display: flex;
	justify-content: center;
	align-items: center;
	background: rgba(0, 0, 0, 0.3);
	left: 0;
	top: 0;
	right: 0;
	bottom: 0;
	z-index: ${zIndex.modalBackdrop};
`;

const Modal = styled.div`
	display: flex;
	flex-direction: column;
	background: #ffffff;
	height: max-content;
	max-height:80%;
	width: 60vw;
	padding: 0;
	border-radius: 10px;
	overflow:hidden;
	z-index: ${zIndex.modal};
	@media (max-width: ${BREAKPOINTS.desktop}px) {
		width: ${(props) => props.widthBefore1000};
	}
`;

const GroupContainer = styled.div`
	display: flex;
	flex-direction: column;
	height: max-content;
	width: 100%;
	padding: 1.5rem;
	border-radius: 10px;
	background: #fff;
	margin: ${(props) => props.margin};
`;

const InfoContainer = styled.div`
	display: flex;
	flex-direction: row;
	justify-content: space-between;
	flex-wrap: wrap;
	height: max-content;
	width: 100%;
	gap: 2rem;
	margin: ${(props) => props.margin};
	padding: ${(props) => props.padding};
`;

const InfoContent = styled.div`
	flex: 1;
	flex-basis: 21%;
	flex-grow: 0;
	flex-direction: column;
	gap: 0.5rem;
`;

const InfoHead = styled.div`
	color: rgba(0, 0, 0, 0.5);
	width: max-content;
`;

const InfoData = styled.div`
	margin: 0.3rem 0 0 0;
	font-weight: 600;
`;

const Functionalities = styled.div`
	display: flex;
	gap: 1rem;
	flex-wrap: wrap;
	width: max-content;
	height: max-content;
`;

const GroupHeader = styled.div`
	width: 100%;
	font-size: 18px;
	font-weight: 600;
	text-align: left;
	margin: ${(props) => props.margin};
`;

const Div = styled.div`
	background: ${(props) => props.background};
	color: ${(props) => props.color};
	position: ${(props) => props.position};
	width: ${(props) => props.width};
	display: flex;
	flex-direction: ${(props) => props.flexDirection};
	justify-content: ${(props) => props.jContent};
	align-items: ${(props) => props.alignItem};
	padding: ${(props) => props.padding};
	margin: ${(props) => props.margin};
	text-align: ${(props) => props.txtAlign};
	font-size: ${(props) => props.fontSize};
	gap:${(props) => props.gap};
	overflow-y:${(props) => props.overflowY};
	height:${(props) => props.height};
	max-height:${(props) => props.maxHeight};
	@media (max-width: ${BREAKPOINTS.desktop}px) {
		justify-content: ${(props) => props.jContentBefore1000};
	}
`;

const Span = styled.span`
	font-size: ${(props) => props.fontSize};
	font-weight: ${(props) => props.fontWeight};
	font-family: ${(props) => props.fontFamily};
	color: ${(props) => props.color};
	margin: ${(props) => props.margin};
	padding: ${(props) => props.padding};
`;

const Row = styled.div`
	display: flex;
	flex-direction: row;
	align-items: center;
	justify-content: space-between;
`;

const List = styled.div`
	display: flex;
	flex-direction: column;
	width: 100%;
	margin: 1rem 0 0 0;
	background: #fff;
	height: max-content;
	gap: 0.5rem 0;
`;
const ListItem = styled.div`
	display: flex;
	pointer-events: ${(props) => props.pointerEvents};
	background: #fff;
	align-items: none;
	justify-content: none;
	padding: 0.5rem;
	list-style: none;
`;

const Divider = styled.div`
	margin:2rem 0 0 0;
	width: 100%;
	border-bottom: 1px solid rgba(0, 0, 0, 0.3);
`;

const BUFFER = {
	width: 114,
	height: 80,
};

const ModuleMap = (props) => {

	const { machineStructure, moduleData, setActiveModule } = props;

	const [modal, showModal] = useState(false);
	const [renderData, setRenderData] = useState(false);
	const [ModuleData, setModuleData] = useState(false);
	const moduleWrapper = useRef(null);

	function placeModules(machineStructure, moduleData) {
		let renderData = [];
		const { machineCoordinates } = machineStructure;
		const { modules } = moduleData;
		for (const module in modules) {
			const { coordinates:moduleCoordinates, error } = modules[module];
			const updatedCoordinates = convertToUiCoordinates(
				moduleCoordinates,
				machineCoordinates,
				moduleWrapper.current
			);
			renderData.push(
				<Module
					{...updatedCoordinates}
					onClick={() => {
						setActiveModule(module)
					}}>
					{error ? <Cross width="25px" /> : <Tickmark width="25px" />}
					&nbsp; Module {module}
				</Module>
			);
		}
		setRenderData(renderData);
	}

	function convertToUiCoordinates(newCoordinates, machineDimensions, wrapperElement) {
		let convertedCoordinates = {};
		const playArea = wrapperElement || null;
		if (!playArea) return { x: 0, y: 0, z: 0, r: 0 };
		const { height: playAreaHeight, width: playAreaWidth } = playArea.getBoundingClientRect();
		for (const axis in newCoordinates) {
			let axisCoordinate = newCoordinates[axis];
			//Only handle the axes which have known dimensions
			if (axis in machineDimensions) {
				const max = machineDimensions[axis];
				let relativeValue;

				//Restricting the value to go beyond the allowed values;
				axisCoordinate = axisCoordinate || 0;
				if (axisCoordinate > max) axisCoordinate = max;

				//Get the relative value for the given coordinate
				relativeValue = axisCoordinate / max;

				//Specific axis handling
				if (axis === "x") {
					relativeValue = relativeValue * (playAreaWidth - BUFFER.width);
				}

				if (axis === "y") {
					relativeValue =
						playAreaHeight -
						BUFFER.height -
						relativeValue * (playAreaHeight - BUFFER.height);
				}
				convertedCoordinates[axis] = Math.max(relativeValue, 0);
			} else {
				convertedCoordinates[axis] = Math.max(axisCoordinate, 0);
			}
		}

		return convertedCoordinates;
	}

	useLayoutEffect(() => {
		placeModules(machineStructure, moduleData);
	}, []);

	return (
		<>
			<Card padding="1rem 0rem 0rem 16px" width="100%">
				<ModulesWrapper id="modulesWrapper" ref={moduleWrapper}>
					{renderData}
				</ModulesWrapper>
			</Card>
			{/* <CSSTransition
				in={modal}
				timeout={1000}
				classNames={"module"}
				unmountOnExit>
				<Overlay>
					<Modal widthBefore1000="80%">{renderModuleData(moduleData)}</Modal>
				</Overlay>
			</CSSTransition> */}
		</>
	);
};

export default ModuleMap;
